// All outbound links to the WHMCS billing portal are centralized here.
// UI components must import from this file rather than hardcoding URLs,
// so the destinations can change in one place.

const base =
  import.meta.env.VITE_WHMCS_BASE_URL ?? "https://billing.theplanetapps.in";

export const whmcs = {
  baseUrl: base,
  storeUrl: import.meta.env.VITE_WHMCS_STORE_URL ?? `${base}/store`,
  loginUrl: import.meta.env.VITE_WHMCS_LOGIN_URL ?? `${base}/login`,
  registerUrl:
    import.meta.env.VITE_WHMCS_REGISTER_URL ?? `${base}/register.php`,
  supportUrl:
    import.meta.env.VITE_WHMCS_SUPPORT_URL ?? `${base}/submitticket.php`,
} as const;

/**
 * Builds a product buy-now URL, preserving UTM params from the current
 * page where available. Use this instead of linking to whmcs.storeUrl
 * directly from a product card.
 */
export function buildWhmcsUrl(path: string, search?: URLSearchParams) {
  const url = new URL(path, whmcs.baseUrl);
  if (search) {
    search.forEach((value, key) => {
      if (key.startsWith("utm_")) url.searchParams.set(key, value);
    });
  }
  return url.toString();
}

export const redirectNoticeCopy =
  "You're being redirected to our secure billing portal to configure and purchase this service.";
